import type { EventId } from '../types/envelope.js';

export class Deduplicator {
  private readonly seen = new Set<EventId>();
  private readonly queue: EventId[] = [];

  constructor(private readonly maxEntries = 1000) {
    if (!Number.isInteger(maxEntries) || maxEntries <= 0) {
      throw new Error(
        'Deduplicator maxEntries must be a positive integer',
      );
    }
  }

  isDuplicate(eventId: EventId): boolean {
    if (this.seen.has(eventId)) {
      return true;
    }

    this.seen.add(eventId);
    this.queue.push(eventId);

    if (this.queue.length > this.maxEntries) {
      const oldest = this.queue.shift();

      if (oldest !== undefined) {
        this.seen.delete(oldest);
      }
    }

    return false;
  }
}
